module.exports = require('./helpers/bundle-url').getBundleURL('63k3W') + "../img/common/common.svg" + "?" + Date.now();